export const OneClickFromCrmStatus = {
  NOT_AVAILABLE: 'NotAvailable',
  PENDING: 'Pending',
  FAILED: 'Failed',
  SUCCEEDED: 'Succeeded',
  ALREADY_TOOK_ACTION: 'AlreadyTookAction',
  CANCELLED: 'Cancelled'
}
